export const CREATE_TRUSTEE = `
mutation CreateTrustee($name: String!, $transferOutFormUrl: String, $postalAddress: String, $streetName: String, $location: String) {
  createTrustee(name: $name, transferOutFormUrl: $transferOutFormUrl, postalAddress: $postalAddress, streetName: $streetName, location: $location) {
    trustee {
      id
      name
      transferOutFormUrl
      postalAddress
      streetName
      location
      company {
        petraId
      }
      trusteeCompanySubscriptions {
        id
        companyVan {
          id
          van
        }
        product {
          id
          name
          fundCode
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const DELETE_TRUSTEE = `
mutation DeleteTrustee($id: ID!) {
  deleteTrustee(id: $id) {
    result
    errors {
      property
      description
    }
  }
}
`;

export const UPDATE_TRUSTEE = `
mutation UpdateTrustee($id: ID!, $name: String!, $transferOutFormUrl: String, $postalAddress: String, $streetName: String, $location: String) {
  updateTrustee(id: $id, name: $name, transferOutFormUrl: $transferOutFormUrl, postalAddress: $postalAddress, streetName: $streetName, location: $location) {
    trustee {
      id
      name
      transferOutFormUrl
      postalAddress
      streetName
      location
      company {
        petraId
      }
      trusteeCompanySubscriptions {
        id
        companyVan {
          id
          van
        }
        product {
          id
          name
          fundCode
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const GET_TRUSTEE = `
query GetTrustee($id: ID!) {
  trustee(id: $id) {
    id
    name
    transferOutFormUrl
    postalAddress
    streetName
    location
    company {
      petraId
    }
    trusteeCompanySubscriptions {
      id
      companyVan {
        id
        van
      }
      product {
        id
        name
        fundCode
      }
    }
    trusteeContactPerson {
      id
      firstName
      middleName
      lastName
      email
      phoneNumber
      emailsInCopy
      activeTrusteeSchemesCount
    }
    trusteeSchemes {
      id
      name
      trustee {
        id
      }
    }
  }
}
`;

export const GET_TRUSTEE_NOTIFICATIONS = `
query GetTrusteeNotifications($id: ID!) {
  trustee(id: $id) {
    id
    notifierRecords {
      id
      notificationType
      status
      message
      recipient
      reference
      createdAt
      updatedAt
      trustee {
        id
        company {
          petraId
        }
      }
    }
  }
}
`;

export const GET_TRUSTEES = `
query {
  trustees {
    id
    name
    company {
      petraId
    }
    trusteeCompanySubscriptions {
      companyVan {
        van
      }
      product {
        name
        fundCode
      }
    }
  }
}
`;

export const GET_TRUSTEE_SCHEME = `
query GetTrusteeScheme($id: ID!) {
  trusteeScheme(id: $id) {
    id
    name
    trustee {
      id
      name
    }
    trusteeContactPerson {
      id
      firstName
      middleName
      lastName
      email
      phoneNumber
      emailsInCopy
      activeTrusteeSchemesCount
    }
  }
}
`;

export const UPDATE_TRUSTEE_SCHEME = `
  mutation UpdateTrusteeScheme($id: ID!, $name: String, $trusteeId: ID) {
    updateTrusteeScheme(id: $id, name: $name, trusteeId: $trusteeId) {
      trusteeScheme {
        id
        name
        trustee {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_TRUSTEE_SCHEME = `
  mutation CreateTrusteeScheme($name: String!, $trusteeId: ID!) {
    createTrusteeScheme(name: $name, trusteeId: $trusteeId) {
      trusteeScheme {
        id
        name
        trustee {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const DELETE_TRUSTEE_SCHEME = `
  mutation DeleteTrusteeScheme($id: ID!) {
    deleteTrusteeScheme(id: $id) {
      result
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_TRUSTEE_CONTACT_PERSON = `
  mutation CreateTrusteeContactPerson(
    $trusteeId: ID!, $firstName: String!, $lastName: String!, $middleName: String,
    $email: String!, $phoneNumber: String, $emailsInCopy: [String!]
  ) {
    createTrusteeContactPerson(
      trusteeId: $trusteeId, firstName: $firstName, lastName: $lastName, middleName: $middleName,
      email: $email, phoneNumber: $phoneNumber, emailsInCopy: $emailsInCopy
    ) {
      trusteeContactPerson {
        id
        firstName
        middleName
        lastName
        email
        phoneNumber
        emailsInCopy
        activeTrusteeSchemesCount
      }
      errors {
        property
        description
      }
    }
  }
`;

export const UPDATE_TRUSTEE_CONTACT_PERSON = `
  mutation UpdateTrusteeContactPerson(
    $id: ID!, $firstName: String, $lastName: String, $middleName: String,
    $email: String, $phoneNumber: String, $emailsInCopy: [String!]
  ) {
    updateTrusteeContactPerson(
      id: $id, firstName: $firstName, lastName: $lastName, middleName: $middleName,
      email: $email, phoneNumber: $phoneNumber, emailsInCopy: $emailsInCopy
    ) {
      trusteeContactPerson {
        id
        firstName
        middleName
        lastName
        email
        phoneNumber
        emailsInCopy
        activeTrusteeSchemesCount
      }
      errors {
        property
        description
      }
    }
  }
`;

export const DELETE_TRUSTEE_CONTACT_PERSON = `
  mutation DeleteTrusteeContactPerson($id: ID!) {
    deleteTrusteeContactPerson(id: $id) {
      result
      errors {
        property
        description
      }
    }
  }
`;
